export function validateInvoice({ recipients, title, amount, dueDate }) {
  if (!recipients.length) return 'Select at least one member.';
  if (!title.trim()) return 'Enter an invoice title.';
  if (!Number.isFinite(Number(amount)) || Number(amount) <= 0) return 'Enter an amount greater than zero.';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dueDate) || Number.isNaN(Date.parse(dueDate)) ||
      new Date(dueDate).toISOString().slice(0, 10) !== dueDate) return 'Choose a valid due date.';
  return '';
}

export function validateRefund(amount, originalPaise) {
  const value = Number(amount);
  if (!String(amount).trim() || !Number.isFinite(value) || value <= 0) return 'Enter a refund amount greater than zero.';
  if (Math.round(value * 100) > originalPaise) return 'Refund cannot exceed the original payment.';
  if (Math.abs(value * 100 - Math.round(value * 100)) > 0.000001) return 'Use no more than two decimal places.';
  return '';
}

export function canReviewPayment(invoice) {
  return ['sent', 'overdue'].includes(invoice?.status) && invoice?.paidVia?.status === 'pending';
}
